module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/magic-87e49e76758b0ca1f64a9046c0de51e4.svg";